import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {WelcomeVo} from '../../common/shared/api/gateway/welcome/WelcomeVo.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 웰컴 팝업 정보 조회
 *
 * Origin: pageNicolasApi.getWelcome
 * API: GET /api/v9/store/popup/welcome
 */
export async function getStorePopupWelcome(
  options?: FetcherOptions
): Promise<ApiResultVo & {result: WelcomeVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v9/store/popup/welcome',
    {
      method: 'GET',
    },
    options
  );

  return response.data;
}
